import axios from 'axios';
const ROOT_URL = process.env.API_URL;
const config = {
  headers:
      {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
      }
};
const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

const asyncValidate = (values, dispatch, props, field) => {
  
  if (field == 'requested_amount') {
    return axios.get(ROOT_URL + '/steps/param?param=amount_approved', config).then(function (result) {
      const max_amount = Number(result.data.amount_approved)
      if (values.requested_amount > max_amount) {
        throw { requested_amount: `El monto máximo al que podés acceder es $ ${max_amount}` }
      }
    }, function (err) {
      if (err) {
        const max_amount = 51200000
        if (values.requested_amount > max_amount) {
          throw { requested_amount: `El monto máximo al que podés acceder es $ ${max_amount}` }
        }
      }
    })
  };
  return sleep(1);
}

export default asyncValidate



/** WEBPACK FOOTER **
 ** ./src/components/Validations/asyncValidationsLoanDescriptionForm.js
 **/